<div class="card">
  <app-header
    titulo="Painel de Produção Retorno"
    descricao="Painel de integração de produção retorno"
  ></app-header>

  <!-- Filtros -->
  <div class="flex align-items-end gap-3 mb-4 flex-wrap">
    <div class="field mb-0">
      <label class="font-medium text-800 block mb-2">Instância</label>
      <app-empresa-dropdown
        [(selecionadas)]="instanciaSelecionada"
        modo="unico"
        (funcaoChange)="onInstanciaChange($event)"
      />
    </div>
    <div class="field mb-0">
      <label class="font-medium text-800 block mb-2">Período Movimentação para Exibição</label>
      <p-calendar
        [(ngModel)]="rangeDates"
        selectionMode="range"
        dateFormat="dd/mm/yy"
        [readonlyInput]="true"
        (onClose)="onDateChange($event)"
        [showIcon]="true"
        placeholder="Selecione o período de movimentação"
        [style]="{ width: '280px' }"
      />
    </div>
  </div>

  <!-- Abas principais -->
  <p-tabView>
    <p-tabPanel *appHasPermission="'ACTION_PRODRET_INDUSTRIAL'">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-cog"></i>
          <span>Produção Industrial</span>
        </div>
      </ng-template>
      <app-producaoindustrial />
    </p-tabPanel>
    <p-tabPanel *appHasPermission="'ACTION_PRODRET_AGRICOLA'">
      <ng-template pTemplate="header">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-sun"></i>
          <span>Produção Agrícola</span>
        </div>
      </ng-template>
      <p-tabView styleClass="mt-2">
        <p-tabPanel *appHasPermission="'ACTION_PRODRET_QUALIDADE'">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-chart-line"></i>
              <span>Qualidade</span>
            </div>
          </ng-template>
          <app-producaoqualidade />
        </p-tabPanel>
        <p-tabPanel *appHasPermission="'ACTION_PRODRET_CANA'">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-sun"></i>
              <span>Produção Cana</span>
            </div>
          </ng-template>
          <app-producaocana />
        </p-tabPanel>
        <p-tabPanel *appHasPermission="'ACTION_PRODRET_DADOSTEC'">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-database"></i>
              <span>Dados Técnicos</span>
            </div>
          </ng-template>
          <app-producaodadostecintegracao />
        </p-tabPanel>
        <p-tabPanel *appHasPermission="'ACTION_PRODRET_PARAMETROS'">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2">
              <i class="pi pi-sliders-h"></i>
              <span>Parâmetros</span>
            </div>
          </ng-template>
          <app-producaoagricola />
        </p-tabPanel>
      </p-tabView>
    </p-tabPanel>
  </p-tabView>
</div>
